<template>
    <Link
        v-if="displaySetting === 'grid'"
        :href="route('web.catalog.manufacturers.show', manufacturer.slug)"
        class="rounded block w-full relative border group sm-card sm-card--clickable"
    >
        <div class="flex items-center justify-center pt-6">
            <div class="w-[90%] h-32 flex items-center justify-center shrink-0 rounded-md bg-gray-150">
                <img
                    v-if="marketingAssetUrl(manufacturer.logo?.external_id)"
                    class="max-h-20 max-w-52"
                    :src="marketingAssetUrl(manufacturer.logo?.external_id, 'man-detail')"
                    :alt="manufacturer.name"
                />
            </div>
        </div>
        <div class="p-6 overflow-hidden h-[10rem]">
            <h2 class="text-lg font-bold mb-1 underline-offset-4 decoration-1 group-hover:underline">
                {{ manufacturer.name }}
            </h2>
            <p class="type-secondary text-sm leading-5">
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag.name }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </p>
        </div>
    </Link>

    <label
        v-else-if="displaySetting === 'select'"
        :for="manufacturer.slug + '-checkbox'"
        class="group flex gap-2 items-center px-4 relative hover:bg-gray-tier-4 active:bg-gray-tier-5 at600:items-center at1024:gap-6"
    >
        <input
            type="checkbox"
            :name="manufacturer.slug + '-checkbox'"
            :id="manufacturer.slug + '-checkbox'"
            v-model="manufacturer.selected"
            class="mt-1 at600:mt-0"
        />
        <span class="hidden at1024:w-44 at1024:flex at1024:justify-center dark:bg-white dark:p-1 dark:rounded">
            <img
                class="max-h-24"
                :src="marketingAssetUrl(manufacturer.logo.external_id, 'man-detail')"
                :alt="manufacturer?.name"
            />
        </span>
        <span class="block">
            <span class="font-medium group-hover:underline">{{ manufacturer.name }}</span>
            <span class="text-gray-400 text-sm" v-if="manufacturer.tags['vendor-category']" aria-hidden="true">
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </span>
            <!--            <p>-->
            <!--                <Pin-->
            <!--                    v-if="user"-->
            <!--                    type="vendor"-->
            <!--                    :id="manufacturer.id"-->
            <!--                    :label="false"-->
            <!--                    custom="bg-blue"-->
            <!--                />-->
            <!--            </p>-->
        </span>
    </label>

    <Link
        v-else
        :href="route('web.catalog.manufacturers.show', manufacturer.slug)"
        class="group hover:bg-gray-tier-5 flex items-center px-4 py-4 active:bg-gray-tier-4"
    >
        <div class="flex rounded-md bg-gray-150 items-center justify-center w-44 h-28 mr-4 shrink-0">
            <img
                class="max-h-20 max-w-[140px]"
                :src="marketingAssetUrl(manufacturer.logo.external_id, 'man-detail')"
                :alt="manufacturer.name"
            />
        </div>
        <div class="w-1/2">
            <span class="text-lg font-bold underline-offset-4 decoration-1 group-hover:underline">{{ manufacturer.name }}</span>
            <p class="type-secondary text-sm font-normal">
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag.name }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </p>
        </div>
        <div class="flex items-center ml-auto gap-4 at1024:mr-8">
            <span class="type-secondary whitespace-nowrap">
                {{ manufacturer.channels.find((channel) => channel?.pivot.type === 1)?.channel }}
            </span>
            <button class="hidden at1024:block w-8">
                <span class="hidden group-hover:block">
                    <BaseSvg name="icon-arrow-forward" />
                </span>
            </button>
        </div>
    </Link>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { inject } from "vue";
import { Link } from "@inertiajs/vue3";
import { useAssetTransforms } from "@/Composables";

const route = inject("route");
defineProps(["manufacturer", "displaySetting"]);

const { marketingAssetUrl } = useAssetTransforms();
</script>
